import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'hooks/apollo';
import { Tooltip } from '@mui/material';
import { buildExportUserRightsDetailsDownloadUrl } from '../../../api';
import { EXPORT_USER_RIGHTS_DETAILS_LIST } from '../../../mutations';
import { AssignmentReturned } from '@mui/icons-material';
import { fileType } from 'constants/fileTypes';
import { useSimpleError } from 'hooks/apolloWrappers';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { convertBase64ToFile } from 'utils/base64FileConversion';
import saveAs from 'file-saver';
import PropTypes from 'prop-types';
import { IconButton } from '@totalsoft/rocket-ui';
import { useOidcAccessToken } from '@axa-fr/react-oidc';
import { getOidcConfigName } from 'utils/functions';

const ExportUserRightsDetailsAction = ({ saving, setSaving }) => {
  const [t] = useTranslation();
  const showError = useSimpleError();
  const { accessToken } = useOidcAccessToken(getOidcConfigName());

  const [exportUserRightsDetailsAnchorEl, setExportUserRightsDetailsAnchorEl] = useState(null);
  const isExportUserRightsDetailsOpen = Boolean(exportUserRightsDetailsAnchorEl);

  const [exportUserRightsDetailsList] = useMutation(EXPORT_USER_RIGHTS_DETAILS_LIST, {
    onCompleted: async ({ exportUserRightsDetailsList }) => {
      let downloadLink = null;
      try {
        if (exportUserRightsDetailsList.fileBytes) {
          saveAs(convertBase64ToFile(exportUserRightsDetailsList.fileBytes), exportUserRightsDetailsList.fileName);
          setSaving(false);
          return;
        }
        downloadLink = await buildExportUserRightsDetailsDownloadUrl(
          exportUserRightsDetailsList.filePath,
          exportUserRightsDetailsList.fileName,
          accessToken
        );
        if (downloadLink) {
          window.location.href = downloadLink;
        }
        setSaving(false);
      } catch (error) {
        setSaving(false);
        showError(error);
      }
    }
  });

  const onExportUserRightsDetails = fileType => {
    exportUserRightsDetailsList({ variables: { fileType: fileType } });
  };

  const handleUserRightsDetailsClose = () => {
    setExportUserRightsDetailsAnchorEl(null);
  };

  const handleUserRightsDetailsClick = event => {
    setExportUserRightsDetailsAnchorEl(event.currentTarget);
  };

  const handleExportUserRightsDetails = fileType => () => {
    setSaving(true);
    onExportUserRightsDetails(fileType);
    setExportUserRightsDetailsAnchorEl(null);
  };

  return (
    <>
      <Tooltip placement='top' title={t('Authorization.ExportUserRightsDetails')}>
        <div>
          <IconButton color='primary' onClick={handleUserRightsDetailsClick} disabled={saving}>
            <AssignmentReturned />
          </IconButton>
          <Menu
            id='render-export-user-rights-details-menu'
            anchorEl={exportUserRightsDetailsAnchorEl}
            open={isExportUserRightsDetailsOpen}
            onClose={handleUserRightsDetailsClose}
          >
            <MenuItem onClick={handleExportUserRightsDetails(fileType.excel)}>{t('Authorization.Excel')}</MenuItem>
            <MenuItem onClick={handleExportUserRightsDetails(fileType.csv)}>{t('Authorization.CSV')}</MenuItem>
          </Menu>
        </div>
      </Tooltip>
    </>
  );
};

ExportUserRightsDetailsAction.propTypes = {
  saving: PropTypes.bool.isRequired,
  setSaving: PropTypes.func.isRequired
};
export default ExportUserRightsDetailsAction;
